import { render, staticRenderFns } from "./PluginExtension.vue?vue&type=template&id=fd499e0a&"
import script from "./PluginExtension.vue?vue&type=script&lang=js&"
export * from "./PluginExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports